const formatNumber = (value, minDigits = 1) =>
    String(value)
        .padStart(minDigits, "0")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const animateCount = (el, target, duration = 1500, minDigits = 1) => {
    const start = performance.now();
    const from = 0;

    const tick = (now) => {
        const elapsed = now - start;
        const t = Math.min(elapsed / duration, 1);
        // easeOutCubic
        const eased = 1 - Math.pow(1 - t, 3);
        const current = Math.round(from + (target - from) * eased);
        el.textContent = formatNumber(current, minDigits);
        if (t < 1) {
            requestAnimationFrame(tick);
        } else {
            el.textContent = formatNumber(target, minDigits);
        }
    };

    requestAnimationFrame(tick);
};

// 指定したセレクタにマッチする em 要素を、ビューポートに入った少し後にカウントアップ
const setupCountUp = (selector, { delay = 600 } = {}) => {
    const targets = document.querySelectorAll(selector);
    if (!targets.length) return;

    // 初期値を0に
    targets.forEach((el) => {
        const target = parseInt(el.textContent.replace(/[^0-9]/g, ""), 10);
        if (Number.isNaN(target)) return;
        const parsedMinDigits = parseInt(el.dataset.minDigits || "1", 10);
        const minDigits = Number.isNaN(parsedMinDigits) ? 1 : parsedMinDigits;
        el.dataset.countTo = String(target);
        el.dataset.minDigits = String(minDigits);
        el.textContent = formatNumber(0, minDigits);
    });

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const el = entry.target;
                if (el.dataset.counted === "1") return;
                el.dataset.counted = "1";
                const target = parseInt(el.dataset.countTo || "0", 10);
                const minDigits = parseInt(el.dataset.minDigits || "1", 10);
                if (Number.isNaN(target) || target <= 0) return;
                setTimeout(() => animateCount(el, target, 1500, Number.isNaN(minDigits) ? 1 : minDigits), delay);
                observer.unobserve(el);
            });
        },
        { threshold: 0.6 },
    );

    targets.forEach((el) => observer.observe(el));
};

const setupFloatingHideOnFooter = () => {
    const floating = document.querySelector(".pg-member-merit-floating");
    const footer = document.querySelector(".l-footer-wrapper");
    if (!floating || !footer) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                floating.classList.toggle("is-hidden", entry.isIntersecting);
            });
        },
        { rootMargin: "0px 0px 0px 0px", threshold: 0 },
    );

    observer.observe(footer);
};

const memberMerit = () => {
    setupCountUp(".pg-member-merit-portal__row-to em");
    setupCountUp(".pg-member-merit-award__google-count-num em");
    setupCountUp(".pg-member-merit-award__portal-big-num");
    setupCountUp(".pg-member-merit-award__portal-count em");
    setupCountUp(".pg-member-merit-award__reviews-stat em");
    setupCountUp(".pg-member-merit-award__legacy-stat em");
    setupFloatingHideOnFooter();
};

export default memberMerit;
